<nav class="navbar navbar-expand-lg fixed-top  nav-section">
    <div class="container">
        <a class="navbar-brand" routerLink="/"><img src="assets/images/logo-southbay.svg" class="logo"
                alt="AC Hotel by Marriott Airport Parking Application"></a>
            <a href="https://parkroll.com/parking-location/lax" target="_blank" ><img src="assets/images/logo-new.png" class="pnr-cls"></a>

        <button class="navbar-toggler" type="button" data-toggle="collapse"
            (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed">
            <span class="navbar-toggler-icon"><i class="ri-menu-3-line"></i></span>
        </button>
        <div class="collapse navbar-collapse flex-grow-0" id="navbarSupportedContent" [ngbCollapse]="!isCollapsed">
            <ul class="navbar-nav text-right">
                <li class="nav-item" [ngClass]="{'active': active==true}"
                >
                    <a class="nav-link" routerLink="/" (click)="isCollapsed = !isCollapsed"><i
                            class="fa fa-user" ></i>Reserve Parking</a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/reservation" (click)="isCollapsed = !isCollapsed">Reservation
                        Status</a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/extend-parking" (click)="isCollapsed = !isCollapsed">Extend
                        Parking</a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" href="http://www.achotellosangelessouthbay.com/" target="_blank"  (click)="isCollapsed = !isCollapsed">Our hotel</a>
                </li>

                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/contact" (click)="isCollapsed = !isCollapsed">Contact</a>
                </li>
                <!-- <li *ngIf="loggedIn" class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/profile" (click)="isCollapsed = !isCollapsed">Profile</a>
                </li> -->
                <li *ngIf="loggedIn" class="nav-item dropdown" routerLinkActive="active">
                    <a class="nav-link dropdown-toggle" href="#" id="navbardrop" data-toggle="dropdown">
                        Profile
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/profile"
                            routerLinkActive="active">View Profile</a>
                        <a class="dropdown-item" (click)="isCollapsed = !isCollapsed" routerLink="/user-change-password"
                            routerLinkActive="active">Change Password</a>
                    </div>

                </li>
                <li *ngIf="loggedIn" class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="/order-details" (click)="isCollapsed = !isCollapsed">My Orders</a>
                </li>
                <li *ngIf="!loggedIn" class="nav-item nav-special" routerLinkActive="active">
                    <a class="nav-link" routerLink="/login" (click)="isCollapsed = !isCollapsed"><span>Login</span></a>
                </li>
                <li *ngIf="loggedIn" class="nav-item nav-special">
                    <a class="nav-link" (click)="logout()"><span>Logout</span></a>
                </li>
            </ul>
        </div>
    </div>
</nav>
<section class="banner_img_top">
  <div class="container" *ngIf="url!='/shuttle'">
    <div class="col-12 bgimg" style="background: url('assets/images/achotel-banner-ad.jpg')">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6"></div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 bgcls">
                <img src="assets/images/handshake.svg" class="iconsize">
                <p> Great news! We are now officially partnered with <a href="https://parkroll.com/parking-location/lax" target="_blank" >ParkRoll.com</a> to provide you with best service, For future bookings visit <a href="https://parkroll.com/parking-location/lax" target="_blank" >ParkRoll.com</a> or <a href="https://parkroll.com/parking-location/lax" target="_blank"   style="text-decoration: underline;">click here</a></p>



            </div>
        </div>
    </div>
  </div>
</section>

<router-outlet></router-outlet>

<footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 footer-sec">
                <p>&copy; {{Year}} AC HOTELS BY MARRIOTT. ALL RIGHTS RESERVED</p>
                <ul class="navbar">
                    <li><a routerLink="/about" routerLinkActive="active" class="nav-item">About</a></li>
                    <li><a routerLink="/contact" routerLinkActive="active" class="nav-item">Contact</a></li>
                    <li><a routerLink="/terms-privacy" routerLinkActive="active" class="nav-item">Terms & Privacy</a>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 payment-sec">

                <ul class="navbar">
                    <li><img src="assets/images/paypal/paypal.png" alt="Paypal"></li>
                    <li><img src="assets/images/paypal/mastercard.png" alt="Mastercard"></li>
                    <li><img src="assets/images/paypal/visa.png" alt="visa"></li>
                    <li><img src="assets/images/paypal/americanexpress.png" alt="Americal Express"></li>
                    <li><img src="assets/images/paypal/discover.png" alt="Discover card"></li>
                    <li>
                        <img src="assets/images/paypal/siteseal_gd_3_h_d_m.gif" alt="godaddy verified and secured">
                    </li>
                </ul>

            </div>
        </div>
    </div>
</footer>
